import httpStore from "@/api/httpStore.js";
var camelize = require("camelize");

export const getReturns = status => {
  return httpStore.get(`/returns/status/${status}`).then(res => res.data);
};

export const getReturn = id => {
  return httpStore.get(`/returns/single/${id}`).then(res => res.data);
};

export const getReturnsStatus = () => {
  return httpStore.get(`/returns/returns_status`).then(res => res.data);
};

export const addImageToReturn = (id, image) => {
  return httpStore
    .post(`returns/image/${id}`, { image })
    .then(res => camelize(res.data));
};

export const addReturnComment = (id, comment) => {
  return httpStore
    .post(`returns/comment/${id}`, { comment })
    .then(res => camelize(res.data));
};

export const createReturnLabel = (id, address = null, packageInfo = null) => {
  return httpStore
    .post(`returns/label/${id}`, { address, packageDetails: packageInfo })
    .then(res => camelize(res.data));
};

export const expireReturnLabel = labelId => {
  return httpStore
    .post(`returns/expire_label/${labelId}`)
    .then(res => camelize(res.data));
};

export const calculateReturnLabel = (
  id,
  address = null,
  packageInfo = null
) => {
  return httpStore
    .post("returns/calculate_label/" + id, {
      address,
      packageDetails: packageInfo
    })
    .then(res => camelize(res.data));
};

export const completeReturn = (
  id,
  amountRefunded,
  currentStatus,
  resolution
) => {
  return httpStore
    .post("returns/complete/" + id, {
      amountRefunded,
      currentStatus,
      resolution
    })
    .then(res => camelize(res.data));
};

export const updateReturn = (
  id,
  returnShipmentPaidBy,
  estimatedRefund,
  amountRefunded,
  resolution
) => {
  return httpStore
    .post("returns/update/" + id, {
      returnShipmentPaidBy,
      estimatedRefund,
      amountRefunded,
      resolution
    })
    .then(res => camelize(res.data));
};

export const markReturnInTransit = id => {
  return httpStore
    .post(`returns/mark_in_transit/${id}`, {})
    .then(res => camelize(res.data));
};

export const receiveReturn = (id, products) => {
  return httpStore
    .post(`returns/receive/${id}`, { products })
    .then(res => camelize(res.data));
};

export const refundReturn = (id, refundData) => {
  return httpStore
    .post(`returns/refund/${id}`, refundData)
    .then(res => camelize(res.data));
};
